
    import {
        computed,
        defineComponent,
        onMounted,
        reactive,
        ref,
        toRefs,
    } from "vue";
    import {useRouter} from "vue-router";
    import {ElMessage} from "element-plus";
    import {updateDataPushUrl} from "@/service/api";
    import store from "@/store";
    import {useApplicationInfo} from "@/hooks/frontApp";
    import {checkUrl} from "@/utils/validate";

    export default defineComponent({
        setup() {
            const router = useRouter();
            const state = reactive({
                formItem: {
                    id: router.currentRoute.value.query.appid,
                    dataPushUrl: "",
                },
                rules: {
                    dataPushUrl: [
                        {required: true, message: "请输入数据推送地址", trigger: "blur"},
                        // { validator: checkUrl, trigger: "blur" }
                    ],
                },
                eventList: [
                    {
                        eventId: "学校id",
                        eventType: "school_updated",
                        desc: "学校基本信息变更",
                    },
                    {
                        eventId: "班级id",
                        eventType: "clazz_updated",
                        desc: "班级基本信息变更",
                    },
                    {
                        eventId: "用户id",
                        eventType: "user_basic_info_updated",
                        desc: "用户基本信息变更",
                    },
                    {
                        eventId: "教师id",
                        eventType: "teacher_clazz_updated",
                        desc: "教师班级变更",
                    },
                    {
                        eventId: "学生id",
                        eventType: "student_clazz_updated",
                        desc: " 学生班级变更",
                    },
                    {
                        eventId: "部门id",
                        eventType: "dept_updated",
                        desc: " 部门基本信息变更",
                    },
                    {
                        eventId: "用户id",
                        eventType: "user_dept_updated",
                        desc: " 用户部门变更",
                    },
                    {
                        eventId: "学生id",
                        eventType: "student_parent_updated",
                        desc: " 学生家长变更",
                    }
                ],
            });
            const formItemRef = ref<any>(null);
            const application = computed(() => store.state.frontApp.application);
            /**
             * 根据appId 获取应用详情
             */
            const getApplicationInfo = async () => {
                await useApplicationInfo(store, state.formItem.id);
            };

            /**
             * 保存数据推送地址
             */
            function saveDataPush() {
                formItemRef.value.validate(async (valid: boolean) => {
                    if (valid) {
                        const params = Object.assign({}, state.formItem);
                        const result = await updateDataPushUrl(params);
                        console.log(result);
                        if (result.code == 1) {
                            ElMessage({message: "保存成功", type: "success"});
                            getApplicationInfo();
                        } else {
                            ElMessage({message: result.msg, type: "error"});
                        }
                    } else {
                        return false;
                    }
                });
            }

            /**
             * 页面一开始加载就调用获取应用详情
             */
            onMounted(async () => {
                if (application.value.dataPushUrl) {
                    state.formItem.dataPushUrl = application.value.dataPushUrl;
                }
            });
            return {
                ...toRefs(state),
                formItemRef,
                saveDataPush,
                application,
            };
        },
    });
